<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.4939 18.1541L10.8273 29.2652C9.90428 29.8805 8.66797 29.2188 8.66797 28.1095V5.88732C8.66797 4.77802 9.90428 4.11636 10.8273 4.73169L27.4939 15.8428C28.3186 16.3926 28.3186 17.6043 27.4939 18.1541Z"
      fill="#0F2D5A"
    />
  </svg>
</template>
